import { createElement as rc } from 'react';
import icons from '../customIcons2';
import { feedbackIconColor, feedbackIconDivStyle } from '../../styling/themes/gl2025/icons';
import logging from '@sstdev/lib_logging';
import { css, useTheme } from 'styled-components';
import PropTypes from 'prop-types';
import BaseIcon from './BaseIcon.gl2025';
import styled from '../../styled';
import { styleObjectToCss } from '../../styling/utilities';

const StyledDiv = styled('div').attrs(props => {
    const { theme, variant, color, size } = props;
    const { darkMode } = theme;

    const colorStyle = feedbackIconColor[darkMode ? 'dark' : 'light'][variant][color];
    const { div: divColor } = colorStyle;

    const divStyle = {
        ...feedbackIconDivStyle[size],
        ...divColor
    };

    return { divStyle };
})`
    ${({ divStyle }) => css`
        ${styleObjectToCss(divStyle)}
    `}
`;

export default function FeedbackIcon(props) {
    const { name, variant = 'primary', size = 'md' } = props;
    let color = props.color || 'primary';
    const theme = useTheme();
    const { darkMode } = theme;

    if (!Object.keys(icons).includes(name)) {
        logging.warn(`No icon found with name ${name}`);
    }

    if (!feedbackIconColor[darkMode ? 'dark' : 'light']?.[variant]?.[color]?.icon) {
        logging.error(
            `No icon color found for variant ${variant} and color ${color} in ${darkMode ? 'dark' : 'light'} mode`
        );
    }
    const iconColor = feedbackIconColor[darkMode ? 'dark' : 'light'][variant][color].icon;

    return rc(StyledDiv, { theme, variant, color, size }, rc(BaseIcon, { name, size, color: iconColor }));
}

FeedbackIcon.propTypes = {
    name: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
    color: PropTypes.oneOf(['primary', 'gray', 'error', 'warning', 'success']).isRequired,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
};

FeedbackIcon.defaultProps = {
    variant: 'primary',
    color: 'primary',
    size: 'md'
};
